export default "https://cdn-static.gokick.com/assets/316c05c5b819a67ca00dcd3ca58b5d19adb19ecb/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";